import React from 'react';
import { string } from 'prop-types';
import { useSelector } from 'react-redux';
import { REGULAR_CLASS_ALL_RATING_CLICK } from 'constants/gtmEvent';
import { getLiveTopicInfo } from 'reduxModules/live/selector';
import useStyles from 'hooks/useStyles';

import styles from './Review.scss';
import RatingComment from 'components/RatingComment';

const Review = ({ id }) => {
  useStyles(styles);
  const { ratings, averageRate, ratingCount } = useSelector(getLiveTopicInfo);

  return (
    <section className={styles.root} id={id}>
      <RatingComment
        ratings={ratings}
        averageRate={averageRate}
        ratingCount={ratingCount}
        ratingLimit={3}
        eventName={REGULAR_CLASS_ALL_RATING_CLICK}
      />
    </section>
  );
};

Review.propTypes = {
  id: string,
};

Review.defaultProps = {
  id: '',
};

export default Review;
